import React from 'react';
import simple from 'react-simple/inline';

const Container = simple('div', {
	backgroundColor: 'white',
	padding: 20,
	fontFamily: 'Helvetica',
	fontSize: 14,
	marginBottom: '20px',
	maxWidth: '1024px',
	paddingTop: 5,
});

const Title = simple('p', {
	color: '#000',
	fontWeight: 'bold',
	fontSize: 20,
	paddingBottom: 10,
});

const Bold = simple('span', {
	fontWeight: 'bold',
});

const Block = simple('div', {
	marginBottom: 10,
});

const EmailLead = ({clientFirstName, clientLastName, clientCompany, clientEmail}) => {
	return (
		<Container>
			<Title>New lead - E Series benefit calculator</Title>
			<Block>
				<div>Company name</div>
				<Bold>{clientCompany}</Bold>
			</Block>
			<Block>
				<div>Client name</div>
				<Bold>
					{clientFirstName} {clientLastName}
				</Bold>
			</Block>
			<Block>
				<div>Client email</div>
				<Bold>{clientEmail}</Bold>
			</Block>
		</Container>
	);
};

export const getPlainTextEmail = () => {
	return 'New lead - E Series benefit calculator';
};

export default EmailLead;
